module.exports = __webpack_public_path__ + "static/media/password-step.5495d159.svg";